var alignment_rtlignore_default = {
  "alignLeft": "bVzbe",
  "textWrapNowrap": "qSyZn",
  "alignRight": "-QjJV",
  "alignCenter": "B5RMs",
  "sizeFullWidth": "_25eYF",
  "renderedInTable": "NwTAg",
  "sizeOriginal": "xlvCk",
  "sizeContent": "ja7eZ",
  "sizeSmall": "a2wGh",
  "sizeSmallCenter": "WCm-b",
  "flex": "_-2-by",
  "LEFT": "S1OKa",
  "CENTER": "-iVMu",
  "RIGHT": "sT1D5",
  "AUTO": "pffNv",
  "JUSTIFY": "CQ-4T"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
